import { DPErrorCodes, DYNAMIC_PAGES_PER_COLLECTION_LIMIT } from './constants'
import type { I18n } from '@wix/wix-data-client-common-standalone'

type ErrorPanelData = {
  title: string
  text: string
  buttonLabel: string
  helpId?: string
}

export const DPErrorPanelData = {
  [DPErrorCodes.TOO_MANY_DYNAMIC_PAGES_FOR_COLLECTION]: ({
    t,
  }: {
    t: I18n['t']
  }): ErrorPanelData => ({
    title: t(
      'Workspace_Dynamic_Page_Error_Too_Many_Dynamic_Pages_For_Collection_Title',
    ),
    text: t(
      'Workspace_Dynamic_Page_Error_Too_Many_Dynamic_Pages_For_Collection_Text',
      {
        dynamic_page_limit: DYNAMIC_PAGES_PER_COLLECTION_LIMIT,
      },
    ),
    buttonLabel: t(
      'Workspace_Dynamic_Page_Error_Too_Many_Dynamic_Pages_For_Collection_Button',
    ),
  }),
  [DPErrorCodes.NO_FIELD_KEY_IN_DB_DRIVER_COLLECTION]: ({
    t,
  }: {
    t: I18n['t']
  }): ErrorPanelData => ({
    title: t('Workspace_Dynamic_Page_With_DB_Driver_Collection_Error_Title'),
    text: t('Workspace_Dynamic_Page_With_DB_Driver_Collection_Error_Text'),
    buttonLabel: t(
      'Workspace_Dynamic_Page_With_DB_Driver_Collection_Error_Button',
    ),
    helpId: '28d400bb-9d4c-4241-8121-a3ace7705849',
  }),
}

export class DynamicPageError extends Error {
  code: string

  constructor(code: string, message?: string) {
    super(message)
    this.name = 'DynamicPageError'
    this.code = code
    Object.setPrototypeOf(this, DynamicPageError.prototype)
  }
}

export class InvalidCharsInPrefixError extends Error {
  constructor(message?: string) {
    super(message)
    Object.setPrototypeOf(this, InvalidCharsInPrefixError.prototype)
  }
}

export class DBDriverDynamicPageError extends Error {
  code: string

  constructor(code: string, message?: string) {
    super(message)
    this.name = 'DBDriverDynamicPageError'
    this.code = code
    Object.setPrototypeOf(this, DBDriverDynamicPageError.prototype)
  }
}
